export default class SaveSolutionHandlerError extends Error {
}
